import React, { useState, useCallback, useEffect } from 'react';
import service from '../../../services/destaquesHome';
import Listagem from '../crud/Listagem';

const DestaquesListagem = props => {

    const decodeJanela = s => {
        if (s === '_blank') {
            return 'Nova';
        } else if ( s === '_self') {
            return 'Mesma';
        }
    }

    const rota = props.carrossel ? "carrossel-home":"destaques-home";

    const config = {
        columns: [
            { label: "Descrição", field: "descricao" },
            { label: "Imagem", field: "imagem", convert: "toImg", width: 300 },
            { label: "Janela", field: "janela", convert: decodeJanela }
        ],
        pagination: {
            limit: 100
        },
        sort: 'ordem',
        search: [
            { label: 'Descrição', field: 'descricao', operators: ['equal', 'contains', 'not_contains'] }
        ]
    }

    const [registros, setRegistros] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(true);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        if(!params){
            params = [];
        }
        params.push(
            {field:"carrossel",operator:"equal",value:props.carrossel}
        );
        
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setRegistros(result);
    }, [config.pagination.limit, config.sort, props.carrossel]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    const reorder = async body => {
        await service.reorder(body);
    }

    useEffect(() => {
        getList([], 0);
    }, [getList]);

    return (
        <>
            <Listagem registros={registros} service={{ getList, upsert, reorder }} config={config} loadingList={loadingList} rota={rota} />
        </>
    )
}

export default DestaquesListagem;
// import React, { useCallback, useEffect, useState } from 'react';
// import { carregaDestaquesHome, updateStatus, upsert } from '../../../services/conteudo';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch, faEdit, faTrashAlt, faLock, faLockOpen, faPlus } from "@fortawesome/free-solid-svg-icons";
// import { useHistory } from 'react-router';

// const DestaquesListagem = props => {

//     const history = useHistory();
//     const [destaquesHome, setDestaquesHome] = useState([]);

//     const setAcao = (acao, id) => {
//         let rota = `/painel/destaques-home/${acao}`;
//         if (id) {
//             rota += `/${id}`;
//         }
//         history.push(rota);
//     };

//     const mudarStatus = async (destaque) => {
//         await updateStatus(destaque);
//         carregarDestaquesHome();
//     };

//     const deletar = async (id) => {
//         if (window.confirm("Deseja mesmo deletar o registro?")) {
//             const obj = { deletado: true }
//             await upsert(obj, id);
//             carregarDestaquesHome();
//         }
//     };

//     const carregarDestaquesHome = useCallback(async () => {
//         const destaqueHomeInicial = await carregaDestaquesHome();
//         setDestaquesHome(destaqueHomeInicial);
//     }, []);

//     useEffect(() => {
//         carregarDestaquesHome();
//     }, [carregarDestaquesHome]);

//     const renderDestaquesHome = () => {
//         return destaquesHome.map(ele => {
//             return (
//                 <tr className="user" key={ele._id}>
//                     <td className="name">{ele.descricao}</td>
//                     <td className="name"><img src={ele.imagem} alt={ele.descricao}/></td>
//                     <td className="name">{ele.carrossel ? "Sim" : "Não"}</td>
//                     <td className="name">{ele.janela === "_blank" ? "Nova aba" : "Mesma aba"}</td>
//                     <td className="active">{ele.ativo ? "Ativo" : "Inativo"}</td>
//                     <td className="icons">
//                         <button className='userButton' onClick={() => { setAcao('form', ele._id) }}><FontAwesomeIcon icon={faEdit} /></button>
//                         <button className='userButton' onClick={() => { mudarStatus(ele._id) }}><FontAwesomeIcon icon={ele.ativo ? faLock : faLockOpen} /></button>
//                         <button className='userButton' onClick={() => { deletar(ele._id) }}><FontAwesomeIcon icon={faTrashAlt} /></button>
//                     </td>
//                 </tr>
//             )
//         })
//     };

//     return (
//         <>
//             <div className="filter">
//                 <input type="text" className='userInput' />
//                 <button className='userButton'><FontAwesomeIcon icon={faSearch} /></button>
//                 <button className='userButton' onClick={() => { setAcao('form') }}><FontAwesomeIcon icon={faPlus} /></button>
//             </div>
//             <div className="users">
//                 <table>
//                     <thead>
//                         <tr className="user">
//                             <td className="name">DESCRIÇÃO</td>
//                             <td className="name">IMAGEM</td>
//                             <td className="name">CARROSSEL</td>
//                             <td className="name">JANELA</td>
//                             <td className="active">STATUS</td>
//                             <td className="icons">AÇÕES</td>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {renderDestaquesHome()}
//                     </tbody>
//                 </table>
//             </div>
//         </>
//     )
// }

// export default DestaquesListagem;